module.exports = __webpack_public_path__ + "img/consultoria_16-9.b7984dfa.webp";